import { useInView } from 'motion/react';
import { useRouter } from 'next/router';

export function useIsInView(ref, options) {
  const { query } = useRouter();
  const inView = useInView(ref, options);
  return query.capture === '1' || inView;
}
